import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../lib/auth';
import { ArrowRight, GoogleLogo } from '@phosphor-icons/react';

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(' ')[0]}`);
      const dest = u.role === 'admin' ? '/admin' : u.role === 'partner' ? '/partner' : (loc.state?.from || '/');
      nav(dest, { replace: true });
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const googleLogin = () => {
    const redirectUrl = window.location.origin + '/auth-callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="p-6 min-h-full flex flex-col justify-center">
      <div className="reg-mark">
        <div className="text-[10px] tracking-[0.32em] uppercase font-bold" style={{ color: 'var(--pk-primary)' }}>— Access</div>
        <h1 className="font-display text-[34px] mt-2 leading-tight">Log in.</h1>
        <p className="text-[12px] text-neutral-600 mt-2">Enter your credentials to continue.</p>
      </div>

      {/* Google OAuth — one-click sign in */}
      <button
        type="button"
        onClick={googleLogin}
        className="mt-6 w-full flex items-center justify-center gap-2 border-2 border-black bg-white h-12 font-bold text-[13px] tracking-[0.06em] brutal-shadow-sm hover:bg-yellow-100 active:translate-x-[2px] active:translate-y-[2px] active:shadow-none transition"
        data-testid="google-login-btn"
      >
        <GoogleLogo size={18} weight="bold" />
        Continue with Google
      </button>

      <div className="my-5 flex items-center gap-3">
        <div className="flex-1 h-px bg-neutral-300" />
        <div className="text-[10px] tracking-[0.24em] uppercase text-neutral-400">or</div>
        <div className="flex-1 h-px bg-neutral-300" />
      </div>

      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="pk-label">Email</label>
          <input type="email" required className="pk-input" value={email} onChange={e => setEmail(e.target.value)} data-testid="login-email" />
        </div>
        <div>
          <label className="pk-label">Password</label>
          <input type="password" required className="pk-input" value={password} onChange={e => setPassword(e.target.value)} data-testid="login-password" />
        </div>
        <button type="submit" disabled={busy} className="pk-btn w-full" data-testid="login-submit">
          {busy ? 'Signing in…' : (<>Log in <ArrowRight size={16} weight="bold" /></>)}
        </button>
      </form>

      <div className="mt-6 text-[12px] text-neutral-600">
        No account? <Link to="/register" className="underline font-bold" data-testid="go-register-link">Register</Link>
      </div>
      <Link to="/" className="mt-4 text-[10px] tracking-[0.24em] uppercase text-neutral-500 underline">← Back to home</Link>
    </div>
  );
};

export default Login;
